import { useState } from "react";
import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { LoadingSpinner } from "@/components/loading-spinner";
import { cn } from "@/lib/utils";

interface LoadingLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
  variant?: "default" | "outline" | "ghost" | "secondary";
  size?: "default" | "sm" | "lg" | "icon";
}

export function LoadingLink({ 
  href, 
  children, 
  className, 
  variant = "default",
  size = "default" 
}: LoadingLinkProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = () => {
    setIsLoading(true);
    // The loading state will be cleared when the new page renders
    // We'll add a small timeout to ensure the user sees the loading state
    setTimeout(() => setIsLoading(false), 2000);
  };

  return (
    <Button 
      variant={variant} 
      size={size}
      className={cn(className)}
      disabled={isLoading}
      asChild={!isLoading}
    >
      {isLoading ? (
        <>
          <LoadingSpinner size="sm" className="mr-2" />
          Loading...
        </>
      ) : (
        <Link href={href} onClick={handleClick}>
          {children}
        </Link>
      )}
    </Button>
  );
}